module.exports = __webpack_public_path__ + "76770116df06988f60b0d9080ce26dae.pdf";